// app/privacy-policy/PrivacyContent.tsx
"use client"

import { Card, CardContent, CardHeader, CardTitle /* … */ } from "@/components/ui/card"
import { POLICY_EFFECTIVE_LABEL } from "@/lib/config/policy-dates"
import { Footer } from "@/components/sections/Footer"

export default function PrivacyContent() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 via-white to-blue-50 dark:from-black dark:via-black dark:to-black">
      <div className="container mx-auto px-4 py-24">
        <div className="max-w-2xl mx-auto">
          <h1 className="text-4xl font-bold mb-8 text-center text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-blue-600">
            Privacy Policy
          </h1>
          <Card className="bg-white dark:bg-zinc-900/50 border-purple-200 dark:border-zinc-800">
            <CardHeader>
              <CardTitle className="text-2xl">Privacy Policy</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <p className="text-gray-600 dark:text-gray-300">
                This Privacy Policy explains how PhantomCodeAI collects, uses, and protects any
                information you provide when visiting our website or purchasing our services. We are
                committed to safeguarding your privacy, and any personal data collected will only be
                used in accordance with this statement. PhantomCodeAI may update this policy from
                time to time, so we encourage you to review this page periodically.
              </p>

              <ul className="list-disc pl-6 text-gray-600 dark:text-gray-300 space-y-2">
                <li>
                  <strong>Information We Collect:</strong> We may collect the following details:
                  <ul className="list-disc pl-6 mt-2 space-y-1">
                    <li>Name</li>
                    <li>Contact details, including email address</li>
                    <li>Demographic details such as postal code, preferences, and interests</li>
                    <li>Other relevant information for customer surveys or offers</li>
                  </ul>
                </li>

                <li>
                  <strong>How We Use Your Information:</strong> We collect data to enhance our
                  services, specifically for:
                  <ul className="list-disc pl-6 mt-2 space-y-1">
                    <li>Internal record-keeping</li>
                    <li>Improving our products and services</li>
                    <li>Sending promotional emails about new features, offers, or updates</li>
                    <li>Conducting market research via email, phone, or mail</li>
                    <li>Personalizing website content based on your preferences</li>
                  </ul>
                </li>

                <li>
                  <strong>Data Security:</strong> We take appropriate security measures to protect
                  against unauthorized access or disclosure of your personal information.
                </li>

                <li>
                  <strong>Use of Cookies:</strong>
                  <p className="mt-2">
                    Cookies are small files placed on your device to enhance your browsing
                    experience. We use cookies and to analyze website traffic, helping us tailor the
                    site to better suit users' needs. These cookies do not grant us access to your
                    personal data beyond what you voluntarily share.
                  </p>
                  <p className="mt-2">
                    You can accept or decline cookies in your browser settings, but disabling
                    authentication cookies may limit access to certain features.
                  </p>
                </li>

                <li>
                  <strong>Controlling Your Personal Information:</strong> You have the right to:
                  <ul className="list-disc pl-6 mt-2 space-y-1">
                    <li>Opt-out of direct marketing communications</li>
                    <li>Update or correct your personal data</li>
                    <li>Request the removal of your data (subject to legal obligations)</li>
                  </ul>
                </li>

                <li>
                  <strong>Data Sharing:</strong> We do not sell, distribute, or lease your personal
                  information to third parties unless required by law or with your consent. However,
                  we may send you promotional information about third parties if you have opted in
                  to receive such updates.
                </li>
              </ul>

              <p className="text-gray-600 dark:text-gray-300 mt-4">
                If you need to update your information or have any concerns, contact us:
              </p>

              <ul className="list-disc pl-6 text-gray-600 dark:text-gray-300 space-y-1">
                <li>
                  <strong>Phone:</strong> +91-8168541082
                </li>
                <li>
                  <strong>Email:</strong> customer-care@phantomcodeai.com, or raise a request via the chat
                  bubble at the bottom right.
                </li>
              </ul>
            </CardContent>
          </Card>

          <p className="text-center text-sm text-gray-500 dark:text-gray-400">
            Last updated {POLICY_EFFECTIVE_LABEL}
          </p>
        </div>
      </div>
      <Footer />
    </div>
  )
}
